"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactNl2br = _interopRequireDefault(require("react-nl2br"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Ava = _interopRequireDefault(require("../Ava"));

var _Menu = require("../Menu");

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

var _moreVert = _interopRequireDefault(require("../icons/more-vert.svg"));

var _humanTime = require("../humanTime");

require("./comment.sass");

var Comment =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Comment, _Component);

  function Comment() {
    (0, _classCallCheck2.default)(this, Comment);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Comment).apply(this, arguments));
  }

  (0, _createClass2.default)(Comment, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          isMine = _this$props.isMine,
          isNew = _this$props.isNew,
          user = _this$props.user,
          text = _this$props.text,
          time = _this$props.time;
      return _react.default.createElement("div", {
        className: (0, _classnames.default)('comment', className, {
          'comment--isNew': isNew,
          'comment--mine': isMine
        })
      }, !isMine && _react.default.createElement(_Tooltip.default, {
        tooltip: user.name
      }, _react.default.createElement(_Ava.default, {
        name: user.name,
        id: user.id
      })), _react.default.createElement("div", {
        className: "comment-content"
      }, _react.default.createElement("div", {
        className: "comment-text"
      }, (0, _reactNl2br.default)(text)), _react.default.createElement("div", {
        className: "comment-date"
      }, (0, _humanTime.humanTime)(time).time)), children && _react.default.createElement(_Menu.MenuIcon, {
        Icon: _moreVert.default,
        className: "comment-more"
      }, children));
    }
  }]);
  return Comment;
}(_react.Component);

exports.default = Comment;
Comment.propTypes = process.env.NODE_ENV !== "production" ? {
  user: _propTypes.default.shape({
    name: _propTypes.default.string.isRequired,
    id: _propTypes.default.number.isRequired
  }),
  text: _propTypes.default.node.isRequired,
  isMine: _propTypes.default.bool,
  isNew: _propTypes.default.bool,
  className: _propTypes.default.string,
  time: _propTypes.default.any
} : {};